import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["_top", "_left", "_right", "_bottom", "_height", "_width", "_centerArrow", "_margin"],
  _excluded2 = ["mainCopy", "tooltipCopy", "hoverMain", "centerArrow", "tooltipLink", "hideIcon", "icon", "iconOpacity", "allowHoverAction", "top", "left", "right", "bottom", "height", "width", "visible", "position", "margin", "mobilePosition", "iconHeight"];
var __jsx = React.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Flex } from 'rebass/styled-components';
import { top, left, right, bottom, height, width, margin, padding } from 'styled-system';
import _ from 'lodash';
import TooltipIcon from './tooltip-icon';
import Clickable from './clickable';
var iconContainerStyles = css(["height:", ";opacity:", ";"], function (props) {
  return props.iconHeight;
}, function (props) {
  return props.iconOpacity;
});
var IconContainer = styled.div.withConfig({
  displayName: "tooltip__IconContainer",
  componentId: "sc-cmfm7t-0"
})(["", ""], iconContainerStyles);
var ClickableIconContainer = styled(Clickable).withConfig({
  displayName: "tooltip__ClickableIconContainer",
  componentId: "sc-cmfm7t-1"
})(["", ""], iconContainerStyles);
var TooltipContainer = styled(Flex).withConfig({
  displayName: "tooltip__TooltipContainer",
  componentId: "sc-cmfm7t-2"
})(["display:flex;align-items:center;position:relative;width:", ";", " ", " cursor:", ";"], function (_ref) {
  var containerWidth = _ref.containerWidth;
  return containerWidth || 'fit-content';
}, margin, padding, function (_ref2) {
  var cursor = _ref2.cursor;
  return cursor || 'default';
});
var StyledTooltip = styled(function (_ref3) {
  var _top = _ref3._top,
    _left = _ref3._left,
    _right = _ref3._right,
    _bottom = _ref3._bottom,
    _height = _ref3._height,
    _width = _ref3._width,
    _centerArrow = _ref3._centerArrow,
    _margin = _ref3._margin,
    props = _objectWithoutProperties(_ref3, _excluded);
  return __jsx(Box, props);
}).withConfig({
  displayName: "tooltip__StyledTooltip",
  componentId: "sc-cmfm7t-3"
})(["", " opacity:0;visibility:hidden;display:none;transition:all 0.3s;&.visible{opacity:1;visibility:visible;display:block;}font-size:12px;line-height:16px;position:", ";bottom:30px;background-color:rgba(44,47,50,0.92);color:#f5f7fa;padding:", ";", " white-space:normal;font-weight:normal;text-align:left;border-radius:10px;z-index:100;", " ", " ", " ", " ", " ", " &:after{content:'';width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:8px solid rgba(44,47,50,0.92);position:absolute;transform:", ";transform-origin:", ";bottom:", ";left:", ";right:", ";}"], function (_ref4) {
  var mobilePosition = _ref4.mobilePosition;
  return (mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.right) && "\n    @media screen and (max-width: 410px) {\n      right: ".concat(mobilePosition.right, ";\n    }\n  ");
}, function (_ref5) {
  var position = _ref5.position;
  return position;
}, function (props) {
  return props.bubblePadding || '15px 18px 16px 21px';
}, margin, top, left, right, bottom, height, width, function (props) {
  return props.leftArrow ? 'rotate(90deg) translateX(25%)' : 'none';
}, function (props) {
  return props.leftArrow ? 'center' : 'top left';
}, function (props) {
  return props.leftArrow ? '50%' : '-7px';
}, function (props) {
  return props.leftArrow ? '-11px' : 'auto';
}, function (props) {
  if (props.centerArrow) {
    return 'calc(50% - 8px)';
  }
  if (props.arrowRight) {
    return props.arrowRight;
  }
  return '61px';
});
var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);
  var _super = _createSuper(Tooltip);
  function Tooltip(props) {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _super.call(this, props);
    _this.state = {
      hover: props.show
    };
    return _this;
  }
  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mainCopy = _this$props.mainCopy,
        tooltipCopy = _this$props.tooltipCopy,
        hoverMain = _this$props.hoverMain,
        centerArrow = _this$props.centerArrow,
        tooltipLink = _this$props.tooltipLink,
        hideIcon = _this$props.hideIcon,
        icon = _this$props.icon,
        _this$props$iconOpaci = _this$props.iconOpacity,
        iconOpacity = _this$props$iconOpaci === void 0 ? 1 : _this$props$iconOpaci,
        _this$props$allowHove = _this$props.allowHoverAction,
        allowHoverAction = _this$props$allowHove === void 0 ? true : _this$props$allowHove,
        topProp = _this$props.top,
        leftProp = _this$props.left,
        rightProp = _this$props.right,
        bottomProp = _this$props.bottom,
        heightProp = _this$props.height,
        widthProp = _this$props.width,
        visible = _this$props.visible,
        position = _this$props.position,
        marginProp = _this$props.margin,
        mobilePosition = _this$props.mobilePosition,
        _this$props$iconHeigh = _this$props.iconHeight,
        iconHeight = _this$props$iconHeigh === void 0 ? '15px' : _this$props$iconHeigh,
        props = _objectWithoutProperties(_this$props, _excluded2);
      var hover = this.state.hover;
      return __jsx(TooltipContainer, props, hoverMain && /*#__PURE__*/React.cloneElement(mainCopy, {
        onMouseEnter: function onMouseEnter() {
          return allowHoverAction ? _this2.setState({
            hover: true
          }) : _.noop();
        },
        onMouseLeave: function onMouseLeave() {
          return allowHoverAction ? _this2.setState({
            hover: false
          }) : _.noop();
        },
        onFocus: function onFocus() {
          return allowHoverAction ? _this2.setState({
            hover: true
          }) : _.noop();
        },
        onBlur: function onBlur() {
          return allowHoverAction ? _this2.setState({
            hover: false
          }) : _.noop();
        }
      }), !hoverMain && mainCopy, !hoverMain && !tooltipLink && !hideIcon && __jsx(IconContainer, {
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            hover: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            hover: false
          });
        },
        iconOpacity: iconOpacity,
        iconHeight: iconHeight
      }, __jsx(TooltipIcon, _extends({
        color: props.grey && 'grey'
      }, icon))), !hoverMain && tooltipLink && __jsx(ClickableIconContainer, {
        onClick: function onClick() {
          return window.open(tooltipLink, "_blank");
        },
        iconOpacity: iconOpacity
      }, __jsx(TooltipIcon, _extends({
        color: props.grey && 'grey'
      }, icon))), tooltipCopy && __jsx(StyledTooltip, {
        className: (hover || visible) && 'visible',
        top: topProp || 'auto',
        left: leftProp || 'auto',
        right: rightProp || '-61px',
        bottom: bottomProp,
        height: heightProp || 'auto',
        width: widthProp || '239px',
        centerArrow: centerArrow,
        arrowRight: props.arrowRight,
        bubblePadding: props.bubblePadding,
        leftArrow: props.leftArrow,
        position: position || 'absolute',
        margin: marginProp || 'unset',
        mobilePosition: mobilePosition
      }, __jsx("p", {
        className: "tooltip-copy"
      }, tooltipCopy)));
    }
  }]);
  return Tooltip;
}(React.Component);
export { Tooltip as default };